<template>
  <div class="invite">
    <div class="friend-welfare">好友 {{desensitizationMobile}} 给你送福利了</div>
    <div class="reg-cen">
      <div class="reg-box">
        <input v-model="regForm.phoneNo" 
        name="phone" 
        type="phone" 
        maxlength="11"
        placeholder="请输入手机号码" 
        class="txt"/>
      </div>
      <div class="reg-box">
        <input v-model="regForm.code"
        name="code"
        type="digit"
        maxlength="6"
        class="txt code-txt"
        placeholder="请输入短信验证码" />
        <div class="code-btn"
        :class="[codeDisable ? 'dis' : '', 'input-inner-right']"
        :inactive="codeDisable"
        @click="sendCode">
          {{ codeDisable? `重新获取(${time}s)`:`获取验证码` }}
        </div>
      </div>
    </div>
    <div class="invite-reg-btn" @click="submitForm"></div>
    <NewGift :isNewGiftShow="isNewGiftShow" />
    <div class="old-user" v-if="isOldUserShow">
			<p>{{popTest}}</p>
      <div class="old-user-btn" @click="downLoadAppFn"></div>
    </div>
    <div class="shadow-bg" v-if="isShadowBgShow" @click="closePop"></div>
    <Loading ref="Loading"/>
  </div>
</template>
   
<script>
import NewGift from "./NewGift.vue";
import { api, execWxShare } from "./../api";
import { ajax, getChannel, getSystem, isWeixin, getUrlParam, checkTel, checkCode } from '../../common/utils/tool';
import { downLoadApp } from '../../common/utils/tool';
import Loading from '../components/loading.vue'

export default {
  components: {
    NewGift,
    Loading
  },
  data() {
    return {
      invitationCode: null,//邀请码
      popTest: '',
      isOldUserShow: false,
      isNewGiftShow: false,
      isShadowBgShow: false,
      friendMobile: null,
      desensitizationMobile: '',//脱敏手机号
      regForm:{
        phoneNo: '',
        code: '',
      },
      codeDisable: false,
      time: 60,
      activeId: null,//活动号
      mobile: null,//手机号
      sys: '',
      bqsTokenKey: tokenKey,
      bqsDevice_no: ''
    };
  },
  methods: {
    //埋点
    buryingPoint(actType){
      let postData = {
        deviceNumber: '',
        qdId: '',
        cyId: '',
        hdId: this.activeId,//活动ID
        actType: actType,
        system: this.sys,
        url: window.location.href,
        slidingScreen: "2",
        custNo: "",
        mobileNo: this.mobile,
        environmentInfo: {
          bqsTokenKey: this.bqsTokenKey,
          gpsProvince: "北京市",
          gpsCity: "北京市"
        },
        terminalInfo: {
          appType: this.sys,
          deviceKey: this.bqsDevice_no
        },
        sys: '',
      };

      ajax({
        url: api.maidianUrl,
        data: postData
      })
    },
    clock() {
      let timer = null
      this.codeDisable = true
      const timeout = () => {
        if (this.time > 0) {
          this.time--
        } else {
          clearInterval(timer)
          this.codeDisable = false
          this.time = 60
        }
      }
      timer = setInterval(() => {
        timeout()
      }, 1000)
    },
    sendCode() {
      let that = this;
      const { phoneNo } = this.regForm;
      if(!that.codeDisable){
        if (!phoneNo) {
          this.$toast('请输入手机号');
          return false;
        } else if (!checkTel(phoneNo)) {
          this.$toast('请输入正确的手机号码');
          return false;
        }
        this.$refs.Loading.showLoading()
        ajax({
          type: 'post',
          url: api.dynamicCode,
          data: {
            phoneNumber: phoneNo,
            codeType: '01'
          },
          success(res){
            that.$refs.Loading.hideLoading()
            let {code, message} = res.statusInfo;
            if(code == 'COMCC00000'){
              that.$toast("短信验证码发送成功");
              that.clock();
            }else {
              that.$toast(message);
            }
          },
          fail() {
            that.$refs.Loading.hideLoading()
          }
        })
      }
    },
    submitAjax() {
      let that = this;
      this.$refs.Loading.showLoading()
      let {activeId, mobile, invitationCode} = this;
      const { phoneNo, code } = this.regForm;

      ajax({
        type: 'post',
        url: api.ldyRegister,
        data: {
          environmentInfo: {gpsProvince: '北京市', gpsCity: '北京市'},
          activeId, //活动id(券ID)
          invitationCode, //邀请码
          inviteActiveId: getUrlParam('inviteActiveId'), //邀请活动id
          mobile: phoneNo, //手机号
          code,//验证码
          regType: 1,//1:h5注册
          qdId: 'zylb1'
        },
        success(res){
          that.$refs.Loading.hideLoading()
          let {state, statusInfo} = res;
          let {code, message} = statusInfo;

          if(code == 'COMCC00000'){
            if(state == '06'){
              that.isOldUserShow = true;
              that.popTest = '注册成功，前往APP使用吧'
            } else {
              that.isNewGiftShow=true;
            }
            that.isShadowBgShow=true;
          } else if(code == 'CUSTEXIST01'){
            that.isOldUserShow = true;
            that.popTest = '您已经是我们的用户咯，暂不能领取新人礼，请前往App借款吧'
            that.isShadowBgShow=true;
          } else if(code == 'APPSTES500' && message == '动态码已验证 重新获取'){
            that.$toast('请先获取验证码');
          } else {
            that.$toast(message);
          }
        },
        fail() {
          that.$refs.Loading.hideLoading()
        }
      })
    },
    submitForm() {
      const { phoneNo, code } = this.regForm
      if (!phoneNo) {
        this.$toast('请输入手机号')
        return false;
      } else if (!checkTel(phoneNo)) {
        this.$toast('请输入正确的手机号码');
        return false;
      } else if (!code) {
        this.$toast('请输入验证码')
        return false;
      } else if (!checkCode(code)) {
        this.$toast('请输入正确验证码')
        return false;
      } else {
        this.submitAjax()
      }
    },
    closePop(){
      this.isOldUserShow = false;
      this.isNewGiftShow=false;
      this.isShadowBgShow=false;
    },
    downLoadAppFn(){
      downLoadApp();
    }
  },
  mounted() {
    this.activeId = getUrlParam("activeId");//活动号
    this.mobile = getUrlParam("mobile");//手机号
    this.invitationCode = getUrlParam("invitationCode");
    let pat = /(\d{3})\d*(\d{4})/
    this.friendMobile = getUrlParam('mobile')
    this.desensitizationMobile = this.friendMobile.replace(pat,'$1****$2');
    this.sys = getSystem();
    this.bqsDevice_no = getUrlParam("bqsDevice_no"); 
    if(isWeixin() == 'MicroMessenger'){
      execWxShare(this.activeId);
    }
    //邀请注册页69
    this.buryingPoint('70')
  }
};
</script>>
